export const getSortDetail = state => state.sort.sortDetail;
export const getListSort = state => state.sort.sorts;
export const getAllSort = state => state.sort.allSorts;
export const getPagination = state => state.sort.pagination;
